import PropTypes from 'prop-types';
import {
    allChartTypes,
    chartWidthValues,
    chartHeightValues,
    chartMetricTimelineTypes,
    defaultIntervalUnit,
    customizeFormOutputTypeChoices, defaultFieldToQuery,
} from './chartConstants';
import {eventAdditionalFiltersPropTypes} from 'utils/proptypes';
import {ChartQuery} from 'entities/chart';


const chartQueryPropTypes = PropTypes.shape({
    query_string: PropTypes.string,
    // TODO add all_fields. They are here too but no one cares about them :(
    additionalFilters: eventAdditionalFiltersPropTypes,
    fields_to_query: PropTypes.string,
    output: PropTypes.string,
    aggs_item: PropTypes.string,
    aggs_item_list: PropTypes.arrayOf(
        PropTypes.shape({
            value: PropTypes.number.isRequired,
            label: PropTypes.string.isRequired,
        }).isRequired,
    ),

    intervalUnit: PropTypes.string,
    intervalNumber: PropTypes.number,
    metric_timeline_type: PropTypes.string,
    metric_aggregations_type: PropTypes.string,
    metric_aggregations_aggs_item: PropTypes.string, // Cross table specific
    pivot_col_aggs_item: PropTypes.string,
    metric_interval: PropTypes.number,

    concordance_query: PropTypes.string,
    concordance_width: PropTypes.number,
    concordance_lines: PropTypes.number,
    // Word cloud stuff
    n_gram: PropTypes.number,
    filtering_lists: PropTypes.arrayOf(
        PropTypes.shape({
            value: PropTypes.number.isRequired,
            label: PropTypes.string.isRequired,
        }).isRequired,
    ),
    // Trending stuff
    trending_or_disappearing: PropTypes.string,
    trending_comparable_period: PropTypes.number,
    trending_period: PropTypes.string,
    nested_terms_include_missing: PropTypes.bool,

    additionalData: PropTypes.shape({
        comment: PropTypes.string,
    }),

    id: PropTypes.number,
});

const chartQueryDefaultProps: ChartQuery = {
    query_string: '*',
    fields_to_query: defaultFieldToQuery,
    output: customizeFormOutputTypeChoices[0][0],
    aggs_item: null,
    aggs_item_list: [],
    intervalUnit: defaultIntervalUnit,
    intervalNumber: 1,
    metric_timeline_type: chartMetricTimelineTypes[0][0],
    metric_aggregations_type: chartMetricTimelineTypes[0][0],
    metric_aggregations_aggs_item: null, // Cross table specific
    pivot_col_aggs_item: null,
    metric_interval: 10,

    concordance_query: '',
    concordance_width: 80,
    concordance_lines: 25,
    // Word cloud stuff
    n_gram: 1,
    filtering_lists: [],

    // Trending stuff
    trending_or_disappearing: 'trending',
    trending_comparable_period: 7,
    trending_period: '',
    nested_terms_include_missing: false,

    all_fields: {},
    additionalFilters: [],
    additionalData: {
        comment: '',
    },
};

const getChartPropTypes = ({idRequired = true, chartQueryNested = false} = {}) => {
    const cpt = {
        id: idRequired ? PropTypes.number.isRequired : PropTypes.number,
        title: PropTypes.string.isRequired,
        description: PropTypes.string,
        type: PropTypes.oneOf(allChartTypes).isRequired,
        width: PropTypes.oneOf(chartWidthValues).isRequired,
        height: PropTypes.oneOf(chartHeightValues).isRequired,
        linearRegression: PropTypes.bool,
        comparablePeriod: PropTypes.bool,
        movingAverageDays: PropTypes.number,
        movingAverageDaysCenter: PropTypes.bool,
        scalingFactor: PropTypes.string,
        barOrientation: PropTypes.oneOf(['vertical', 'horizontal']),
        barSortOrder: PropTypes.oneOf(['high_to_low', 'low_to_high']),
        dataLabelPosition: PropTypes.oneOf(['off', 'above', 'inside']),
    };

    if (chartQueryNested) {
        // @ts-ignore
        cpt.chartQuery = chartQueryPropTypes.isRequired;
    }

    return PropTypes.shape(cpt);
};

const chartDataItemPropTypes = PropTypes.objectOf(
    PropTypes.oneOfType([
        PropTypes.number,
        PropTypes.string,
        PropTypes.arrayOf(PropTypes.string),
    ]).isRequired,
);

const chartDataPropTypes = PropTypes.arrayOf(
    chartDataItemPropTypes.isRequired,
);

export {
    getChartPropTypes,
    chartQueryPropTypes,
    chartQueryDefaultProps,
    chartDataItemPropTypes,
    chartDataPropTypes,
};
